module.exports = __webpack_public_path__ + "static/media/navigation-arrow-up.6c84ba13.svg";